import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IReflectionContributor } from "../../models/reflection-contributor-list.models";

@Component({
  selector: "reflection-contributor-list",
  templateUrl: "./reflection-contributor-list.component.html",
  styleUrls: ["./reflection-contributor-list.component.less"],
})
export class ReflectionContributorListComponent implements OnInit {
  @Input() public contributors: IReflectionContributor[];
  @Input() public activeContributorId: string;

  @Output() public onContributorSelection = new EventEmitter<IReflectionContributor>();

  public ngOnInit(): void {
    // logic will be added in the upcoming PRs
  }

  public isContributorCurrent(contributorId: string): boolean {
    return contributorId === this.activeContributorId;
  }

  public selectContributor(contributor: IReflectionContributor): void {
    this.onContributorSelection.emit(contributor);
  }
}
